var h=document.querySelector('.hdr'),b=document.querySelector('.burger');
if(b){b.addEventListener('click',function(){var o=h.classList.toggle('open');b.setAttribute('aria-expanded',o)})}
(function(){
var d=document,de=d.documentElement,rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var $$=function(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s))};
// header
var hd=$$('.hdr')[0];function sc(){if(hd)hd.classList.toggle('scrolled',window.scrollY>20)}sc();
// découpe des titres en mots
$$('[data-split]').forEach(function(el){var i=0;
  (function walk(n){Array.prototype.slice.call(n.childNodes).forEach(function(c){
    if(c.nodeType===3){var f=d.createDocumentFragment();c.textContent.split(/(\s+)/).forEach(function(t){
      if(!t)return;if(/^\s+$/.test(t)){f.appendChild(d.createTextNode(' '));return}
      var w=d.createElement('span');w.className='w';var s=d.createElement('span');s.textContent=t;s.style.setProperty('--i',i++);w.appendChild(s);f.appendChild(w)});
      n.replaceChild(f,c)}else if(c.nodeType===1){walk(c)}})})(el)});
// apparitions
var rv=$$('.rv'),vh=window.innerHeight;
if(!rm&&'IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
  rv.forEach(function(el){if(el.getBoundingClientRect().top<vh*.92){el.classList.add('in')}else{io.observe(el)}});
  var lines=$$('.flowline,.flow6');lines.forEach(function(el){io.observe(el)});
}else{rv.concat($$('.flowline,.flow6')).forEach(function(el){el.classList.add('in')})}
// compteurs
function count(el){var t=+el.getAttribute('data-count'),dur=1400,s=null;
  if(rm){el.textContent=t;return}
  function f(ts){if(!s)s=ts;var p=Math.min((ts-s)/dur,1),e=1-Math.pow(1-p,3);el.textContent=Math.round(t*e);if(p<1)requestAnimationFrame(f)}requestAnimationFrame(f)}
var cs=$$('[data-count]');
if('IntersectionObserver' in window){var co=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){count(e.target);co.unobserve(e.target)}})},{threshold:.6});cs.forEach(function(c){c.textContent='0';co.observe(c)})}
else{cs.forEach(function(c){c.textContent=c.getAttribute('data-count')})}
// parallaxe des formes
var ps=$$('[data-speed]');
function par(){var y=window.scrollY;if(y>1400)return;ps.forEach(function(p){var s=+p.getAttribute('data-speed');p.style.transform='translate3d(0,'+(y*s).toFixed(1)+'px,0)'})}
if(!rm&&ps.length){par()}
var tk=false;window.addEventListener('scroll',function(){if(tk)return;tk=true;requestAnimationFrame(function(){sc();if(!rm&&ps.length)par();tk=false})},{passive:true});
})();
(function(){
var d=document,sec=d.querySelector('.stsec'),pin=sec&&sec.querySelector('.pin');if(!pin)return;
var sts=[].slice.call(d.querySelectorAll('.st')),sc=[].slice.call(d.querySelectorAll('.scene')),vl=d.querySelector('.vline'),N=sts.length;
var cur=0,engaged=false,snapping=0,released=null,lastY=window.scrollY,lastStep=0,lastWheel=0,tY=null,tDone=false;
function pos(i){var li=sts[i],row=li.querySelector('.trow');var y=row.offsetTop+row.offsetHeight/2;vl.style.setProperty('--my',y+'px');vl.style.setProperty('--fh',y+'px')}
function set(i){cur=i;sts.forEach(function(s,k){s.classList.toggle('on',k===i)});sc.forEach(function(s,k){s.classList.toggle('on',k===i);s.setAttribute('aria-hidden',k===i?'false':'true')});pos(i)}
function step(dir){var n=cur+dir;if(n<0||n>=N)return false;set(n);lastStep=Date.now();return true}
function vh(){return window.innerHeight}
function engage(at){engaged=true;released=null;set(at);var r=pin.getBoundingClientRect();snapping=Date.now();
  if(Math.abs(r.top)>1){window.scrollTo({top:window.scrollY+r.top,behavior:'smooth'})}
  d.documentElement.classList.add('st-lock')}
function release(side){engaged=false;released=side;d.documentElement.classList.remove('st-lock')}
function busy(){return Date.now()-snapping<750||Date.now()-lastStep<650}
// molette / pavé tactile
window.addEventListener('wheel',function(e){
  if(!engaged)return;var dir=e.deltaY>0?1:e.deltaY<0?-1:0;if(!dir)return;
  var now=Date.now(),gap=now-lastWheel;lastWheel=now;
  if(Date.now()-snapping<750){e.preventDefault();return}
  var can=(dir>0&&cur<N-1)||(dir<0&&cur>0);
  if(!can){release(dir>0?'down':'up');return}
  e.preventDefault();
  if(Date.now()-lastStep<650)return;            // le geste en cours est déjà compté
  if(gap<110&&lastStep&&now-lastStep<1400&&Math.abs(e.deltaY)<40)return; // inertie du pavé tactile
  step(dir)},{passive:false});
// tactile
window.addEventListener('touchstart',function(e){if(!engaged)return;tY=e.touches[0].clientY;tDone=false},{passive:true});
window.addEventListener('touchmove',function(e){if(!engaged||tY===null)return;var dy=tY-e.touches[0].clientY;
  if(tDone){if(e.cancelable)e.preventDefault();return}if(Math.abs(dy)<3)return;var dir=dy>0?1:-1;var can=(dir>0&&cur<N-1)||(dir<0&&cur>0);
  if(!can){if(!tDone){release(dir>0?'down':'up')}return}
  if(e.cancelable)e.preventDefault();
  if(!tDone&&Math.abs(dy)>=40&&!busy()){tDone=true;step(dir)}},{passive:false});
window.addEventListener('touchend',function(){tY=null});
// clavier
window.addEventListener('keydown',function(e){if(!engaged)return;var t=e.target;if(t&&/INPUT|TEXTAREA|SELECT/.test(t.tagName))return;
  var dir=({ArrowDown:1,PageDown:1,' ':1,ArrowUp:-1,PageUp:-1})[e.key];if(!dir)return;
  var can=(dir>0&&cur<N-1)||(dir<0&&cur>0);if(!can){release(dir>0?'down':'up');return}
  e.preventDefault();if(!busy())step(dir)});
// engagement selon le sens et la position de la section
function onScroll(){var y=window.scrollY,dir=y>lastY?1:y<lastY?-1:0;lastY=y;var r=pin.getBoundingClientRect(),h=vh();
  if(engaged){if(Date.now()-snapping>900&&Math.abs(r.top)>8){release(r.top<0?'down':'up')}return}
  if(released==='down'&&r.top<-.6*h)released=null;if(released==='up'&&r.top>.6*h)released=null;
  if(Date.now()-snapping<900)return;
  if(dir>0&&released!=='down'&&r.top<.35*h&&r.top>-.5*h){engage(0)}
  else if(dir<0&&released!=='up'&&r.top>-.65*h&&r.top<.35*h){engage(N-1)}}
var tk=false;window.addEventListener('scroll',function(){if(tk)return;tk=true;requestAnimationFrame(function(){onScroll();tk=false})},{passive:true});
sts.forEach(function(s,i){s.querySelector('.sb').addEventListener('click',function(){if(!engaged){var r=pin.getBoundingClientRect();engage(i);return}if(i!==cur){set(i);lastStep=Date.now()}})});
window.addEventListener('resize',function(){pos(cur)});window.addEventListener('load',function(){pos(cur)});
set(0);
})();
